export { Tag, TAG_COMPONENT_NAME } from './Tag';
export { getBackgroundColorToken, getBorderColorToken } from './Tag';